import axios from "axios";

const ENDPOINT_KEY = "supplier-order";
const ENDPOINT_URI = "/supplier-order";

export default function useSupplyService() {
  return {
    queryKey: ENDPOINT_KEY,
    getAllSupplyOrders: async (search = "", page = 1, limit = 10) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (search) {
        params.append("search", search);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, { params });
      return response.data.payload;
    },
    getSupplyOrderById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    createSupplyOrder: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, payload);
      return response.data.payload;
    },
    updateSupplyOrder: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteSupplyOrder: async (id) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    deleteSupplyOrderPayment: async ({ id, paymentId }) => {
      const response = await axios.delete(
        `${ENDPOINT_URI}/${id}/payment/${paymentId}`,
      );
      return response.data.payload;
    },
    addNewPaymentForSupplyOrder: async ({ id, payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/${id}/payment`, payload);
      return response.data.payload;
    },
    updateSupplyOrderPayment: async ({ id, paymentId, payload }) => {
      const response = await axios.put(
        `${ENDPOINT_URI}/${id}/payment/${paymentId}`,
        payload,
      );
      return response.data.payload;
    },
  };
}
